import asyncActionTypes from '../actions/types.js';

const initialState = {
};

const seatMapBanner = ( state = initialState, action ) => {
  switch (action.type) {
    case asyncActionTypes.SEAT_MAP_BANNER.START:
      return {
        ...state,
      };
    case asyncActionTypes.SEAT_MAP_BANNER.SUCCESS:

      const SeatMapBanner = action.payload?.data;
      
      return {
        ...state,
        SeatMapBanner,
      };
    case asyncActionTypes.SEAT_MAP_BANNER.FAIL:
      return {
        ...state,
        error : action.error,
      };
    default:
      return state;
  }
};

export default seatMapBanner;